skrilla.controller('betTickerCtrl', function ($scope, cacheService, srefService) {
    $scope.pageKey = "betTicker";
    $scope.bets = cacheService.getObjectOrElse("betTickerTable", []);

    function clickUsername(bet, field, event){
        srefService.go("userDetails", {id: bet.userId}, event);
    }

    function clickRow(bet, event){
        srefService.go("betDetails", {id: bet.id}, event);
    }

    $scope.tableData = {
        columns: [
            {title:"Username", field: "username", onClick: clickUsername, isUsernameLink: true, tags: "userTags"},
            {title:"Marketing", field: "marketingCategory"},
            {title: "Bet Name", field: "name"},
            {title: "Entry Id", field: "entryId", filter: {func: (it) => { return `B-${it}`}}},
            {title: "Selection Count", field: "selectionCount"},
            {title: "Stake", field: "stake", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
            {title: "Stake Source", field: "stakeSource"},
            {title: "Odds", field: "odds"},
            {title: "Potential Payout", field: "potentialPayout", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
            {title: "Payout", field: "paidOut", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
            {title: "Winnings", field: "winnings", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
            {title: "Status", field: "status"},
            {title: "Result", field: "result"},
            {title: "Currency", field: "currency"},
            {title: "Rejection Reason", field: "reason"},
            {title: "Created At", field: "createdAt", filter:{name: 'dateTimeFormatter'}},
            {title: "Updated At", field: "updatedAt", filter:{name: 'dateTimeFormatter'}},
            {title: "Updated By", field: "updatedBy"}
            ],
        rows: {onClick: clickRow},
        isSkrillaTable: true,
        data: $scope.bets
    }
});
